//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { ClientBaseQus } from "../ClientBaseQus";

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class QuestionClient extends ClientBaseQus {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? "";
  }

  /**
   * @return OK
   */
  migrateStr2LearnableMigrate(): Promise<void> {
    let url_ = this.baseUrl + "/v1/MigrateStr2Learnable";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMigrateStr2LearnableMigrate(_response);
      });
  }

  protected processMigrateStr2LearnableMigrate(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  configGet(key: string): Promise<ConfigDto> {
    let url_ = this.baseUrl + "/v1/Config/{key}";
    if (key === undefined || key === null) throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace("{key}", encodeURIComponent("" + key));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processConfigGet(_response);
      });
  }

  protected processConfigGet(response: Response): Promise<ConfigDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ConfigDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ConfigDto>(null as any);
  }

  /**
   * @return OK
   */
  consumerModelGet(identifier: string): Promise<ItemDto> {
    let url_ = this.baseUrl + "/v1/ConsumerModel/{identifier}";
    if (identifier === undefined || identifier === null) throw new Error("The parameter 'identifier' must be defined.");
    url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processConsumerModelGet(_response);
      });
  }

  protected processConsumerModelGet(response: Response): Promise<ItemDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ItemDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ItemDto>(null as any);
  }

  /**
   * @return OK
   */
  healthGet(): Promise<void> {
    let url_ = this.baseUrl + "/v1/Health";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHealthGet(_response);
      });
  }

  protected processHealthGet(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  lookupGetCustomers(api_version: string | undefined): Promise<{ [key: string]: string }> {
    let url_ = this.baseUrl + "/api/Lookup/customers?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLookupGetCustomers(_response);
      });
  }

  protected processLookupGetCustomers(response: Response): Promise<{ [key: string]: string }> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (resultData200) {
          result200 = {} as any;
          for (let key in resultData200) {
            if (resultData200.hasOwnProperty(key))
              (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
          }
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<{ [key: string]: string }>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  lookupGetDataTypes(api_version: string | undefined): Promise<{ [key: string]: string }> {
    let url_ = this.baseUrl + "/api/Lookup/datatypes?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLookupGetDataTypes(_response);
      });
  }

  protected processLookupGetDataTypes(response: Response): Promise<{ [key: string]: string }> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (resultData200) {
          result200 = {} as any;
          for (let key in resultData200) {
            if (resultData200.hasOwnProperty(key))
              (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
          }
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<{ [key: string]: string }>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  lookupGetFormats(api_version: string | undefined): Promise<{ [key: string]: string }> {
    let url_ = this.baseUrl + "/api/Lookup/formats?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLookupGetFormats(_response);
      });
  }

  protected processLookupGetFormats(response: Response): Promise<{ [key: string]: string }> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (resultData200) {
          result200 = {} as any;
          for (let key in resultData200) {
            if (resultData200.hasOwnProperty(key))
              (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
          }
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<{ [key: string]: string }>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  lookupGetStatuses(api_version: string | undefined): Promise<StatusDto[]> {
    let url_ = this.baseUrl + "/api/Lookup/statuses?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLookupGetStatuses(_response);
      });
  }

  protected processLookupGetStatuses(response: Response): Promise<StatusDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(StatusDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<StatusDto[]>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  lookupGetInteractionTypeProperty(api_version: string | undefined): Promise<InteractionTypePropertyDto[]> {
    let url_ = this.baseUrl + "/api/Lookup/interactiontypeproperty?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLookupGetInteractionTypeProperty(_response);
      });
  }

  protected processLookupGetInteractionTypeProperty(response: Response): Promise<InteractionTypePropertyDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(InteractionTypePropertyDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<InteractionTypePropertyDto[]>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  lookupGetInteractionTypes(api_version: string | undefined): Promise<InteractionTypeDto[]> {
    let url_ = this.baseUrl + "/api/Lookup/interactiontypes?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLookupGetInteractionTypes(_response);
      });
  }

  protected processLookupGetInteractionTypes(response: Response): Promise<InteractionTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(InteractionTypeDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<InteractionTypeDto[]>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  lookupGetMediaTypes(api_version: string | undefined): Promise<{ [key: string]: string }> {
    let url_ = this.baseUrl + "/api/Lookup/mediatypes?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLookupGetMediaTypes(_response);
      });
  }

  protected processLookupGetMediaTypes(response: Response): Promise<{ [key: string]: string }> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (resultData200) {
          result200 = {} as any;
          for (let key in resultData200) {
            if (resultData200.hasOwnProperty(key))
              (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
          }
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<{ [key: string]: string }>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  lookupGetTextAndMediaTypes(api_version: string | undefined): Promise<TextAndMediaTypesDto[]> {
    let url_ = this.baseUrl + "/api/Lookup/textandmediatypes?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLookupGetTextAndMediaTypes(_response);
      });
  }

  protected processLookupGetTextAndMediaTypes(response: Response): Promise<TextAndMediaTypesDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(TextAndMediaTypesDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TextAndMediaTypesDto[]>(null as any);
  }

  /**
   * @param api_version (optional)
   * @param body (optional)
   * @return OK
   */
  publishPublish(
    api_version: string | undefined,
    body: QuestionPublishRequest | undefined
  ): Promise<PublishQuestionResponse> {
    let url_ = this.baseUrl + "/api/Publish?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPublishPublish(_response);
      });
  }

  protected processPublishPublish(response: Response): Promise<PublishQuestionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PublishQuestionResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<PublishQuestionResponse>(null as any);
  }

  /**
   * @param contentId (optional)
   * @param api_version (optional)
   * @return OK
   */
  publishGetQuestionId(contentId: string | undefined, api_version: string | undefined): Promise<number> {
    let url_ = this.baseUrl + "/api/Publish/GetQuestionId?";
    if (contentId === null) throw new Error("The parameter 'contentId' cannot be null.");
    else if (contentId !== undefined) url_ += "contentId=" + encodeURIComponent("" + contentId) + "&";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPublishGetQuestionId(_response);
      });
  }

  protected processPublishGetQuestionId(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  questionGetList(body: number[] | undefined): Promise<QuestionDto[]> {
    let url_ = this.baseUrl + "/v1/Question/list";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processQuestionGetList(_response);
      });
  }

  protected processQuestionGetList(response: Response): Promise<QuestionDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(QuestionDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  questionGetListByClassifications(body: string[] | undefined): Promise<QuestionDto[]> {
    let url_ = this.baseUrl + "/v1/Question/GetListByClassifications";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processQuestionGetListByClassifications(_response);
      });
  }

  protected processQuestionGetListByClassifications(response: Response): Promise<QuestionDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(QuestionDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  questionGetListByClassificationsIntersect(body: ClassificationScopeRequest | undefined): Promise<QuestionDto[]> {
    let url_ = this.baseUrl + "/v1/Question/GetListByClassificationsIntersect";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processQuestionGetListByClassificationsIntersect(_response);
      });
  }

  protected processQuestionGetListByClassificationsIntersect(response: Response): Promise<QuestionDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(QuestionDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionDto[]>(null as any);
  }

  /**
   * @return OK
   */
  questionGet(id: number): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/v1/Question/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processQuestionGet(_response);
      });
  }

  protected processQuestionGet(response: Response): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = QuestionDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  questionPut(id: number, body: QuestionDto | undefined): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/v1/Question/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processQuestionPut(_response);
      });
  }

  protected processQuestionPut(response: Response): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = QuestionDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionDto>(null as any);
  }

  /**
   * @return OK
   */
  questionDelete(id: number): Promise<number> {
    let url_ = this.baseUrl + "/v1/Question/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processQuestionDelete(_response);
      });
  }

  protected processQuestionDelete(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @return OK
   */
  questionGetByIdentifier(identifier: string): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/v1/Question/GetByIdentifier/{identifier}";
    if (identifier === undefined || identifier === null) throw new Error("The parameter 'identifier' must be defined.");
    url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processQuestionGetByIdentifier(_response);
      });
  }

  protected processQuestionGetByIdentifier(response: Response): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = QuestionDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  questionValidate(body: QuestionDto | undefined): Promise<ValidationDto> {
    let url_ = this.baseUrl + "/v1/Question/Validate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processQuestionValidate(_response);
      });
  }

  protected processQuestionValidate(response: Response): Promise<ValidationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ValidationDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ValidationDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  questionPost(body: QuestionDto | undefined): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/v1/Question";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processQuestionPost(_response);
      });
  }

  protected processQuestionPost(response: Response): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = QuestionDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionDto>(null as any);
  }

  /**
   * @param questionId (optional)
   * @return OK
   */
  questionCopyQuestion(questionId: number | undefined): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/v1/Question/CopyQuestion?";
    if (questionId === null) throw new Error("The parameter 'questionId' cannot be null.");
    else if (questionId !== undefined) url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processQuestionCopyQuestion(_response);
      });
  }

  protected processQuestionCopyQuestion(response: Response): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = QuestionDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionDto>(null as any);
  }

  /**
   * @param interactionTypeId (optional)
   * @param customerId (optional)
   * @param api_version (optional)
   * @return OK
   */
  templateGetTemplates(
    interactionTypeId: number | undefined,
    customerId: string | undefined,
    api_version: string | undefined
  ): Promise<TemplateDto[]> {
    let url_ = this.baseUrl + "/api/Template/GetTemplates?";
    if (interactionTypeId === null) throw new Error("The parameter 'interactionTypeId' cannot be null.");
    else if (interactionTypeId !== undefined)
      url_ += "interactionTypeId=" + encodeURIComponent("" + interactionTypeId) + "&";
    if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
    else if (customerId !== undefined) url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTemplateGetTemplates(_response);
      });
  }

  protected processTemplateGetTemplates(response: Response): Promise<TemplateDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(TemplateDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TemplateDto[]>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  templateGetTemplateById(id: number, api_version: string | undefined): Promise<TemplateDto> {
    let url_ = this.baseUrl + "/api/Template/{id}?";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTemplateGetTemplateById(_response);
      });
  }

  protected processTemplateGetTemplateById(response: Response): Promise<TemplateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TemplateDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TemplateDto>(null as any);
  }

  /**
   * @param api_version (optional)
   * @param body (optional)
   * @return OK
   */
  templateAddOrUpdateTemplate(api_version: string | undefined, body: TemplateDto | undefined): Promise<number> {
    let url_ = this.baseUrl + "/api/Template?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTemplateAddOrUpdateTemplate(_response);
      });
  }

  protected processTemplateAddOrUpdateTemplate(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @return OK
   */
  userGet(): Promise<UserDto> {
    let url_ = this.baseUrl + "/v1/User";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserGet(_response);
      });
  }

  protected processUserGet(response: Response): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UserDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserDto>(null as any);
  }

  /**
   * @return OK
   */
  userCreate(): Promise<void> {
    let url_ = this.baseUrl + "/v1/User/Create";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserCreate(_response);
      });
  }

  protected processUserCreate(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  userUsers(): Promise<UserDto[]> {
    let url_ = this.baseUrl + "/v1/User/Users";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserUsers(_response);
      });
  }

  protected processUserUsers(response: Response): Promise<UserDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(UserDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserDto[]>(null as any);
  }

  /**
   * @param api_version (optional)
   * @param body (optional)
   * @return OK
   */
  whereUsedGetWhereUsedQuestionImage(
    api_version: string | undefined,
    body: WhereUsedImageRequest | undefined
  ): Promise<WhereUsedDto[]> {
    let url_ = this.baseUrl + "/api/WhereUsed/WhereUsedQuestionImage?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processWhereUsedGetWhereUsedQuestionImage(_response);
      });
  }

  protected processWhereUsedGetWhereUsedQuestionImage(response: Response): Promise<WhereUsedDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(WhereUsedDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<WhereUsedDto[]>(null as any);
  }
}

export class ClassificationDto implements IClassificationDto {
  rootId?: string;
  classificationId?: string;

  constructor(data?: IClassificationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rootId = _data["rootId"];
      this.classificationId = _data["classificationId"];
    }
  }

  static fromJS(data: any): ClassificationDto {
    data = typeof data === "object" ? data : {};
    let result = new ClassificationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rootId"] = this.rootId;
    data["classificationId"] = this.classificationId;
    return data;
  }
}

export interface IClassificationDto {
  rootId?: string;
  classificationId?: string;
}

export class ClassificationScopeRequest implements IClassificationScopeRequest {
  scopes?: Scope[] | undefined;

  constructor(data?: IClassificationScopeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["scopes"])) {
        this.scopes = [] as any;
        for (let item of _data["scopes"]) this.scopes!.push(Scope.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ClassificationScopeRequest {
    data = typeof data === "object" ? data : {};
    let result = new ClassificationScopeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.scopes)) {
      data["scopes"] = [];
      for (let item of this.scopes) data["scopes"].push(item.toJSON());
    }
    return data;
  }
}

export interface IClassificationScopeRequest {
  scopes?: Scope[] | undefined;
}

export class ConfigDto implements IConfigDto {
  key?: string | undefined;
  value?: string | undefined;

  constructor(data?: IConfigDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data["key"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): ConfigDto {
    data = typeof data === "object" ? data : {};
    let result = new ConfigDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["key"] = this.key;
    data["value"] = this.value;
    return data;
  }
}

export interface IConfigDto {
  key?: string | undefined;
  value?: string | undefined;
}

export class Configuration implements IConfiguration {
  key?: string | undefined;
  value?: string | undefined;

  constructor(data?: IConfiguration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data["key"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): Configuration {
    data = typeof data === "object" ? data : {};
    let result = new Configuration();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["key"] = this.key;
    data["value"] = this.value;
    return data;
  }
}

export interface IConfiguration {
  key?: string | undefined;
  value?: string | undefined;
}

export class DeviationDto implements IDeviationDto {
  textMediaTypeId?: number;
  textDeviation?: number;
  mediaDeviation?: number;
  correctResponsePatternDeviation?: number | undefined;

  constructor(data?: IDeviationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.textMediaTypeId = _data["textMediaTypeId"];
      this.textDeviation = _data["textDeviation"];
      this.mediaDeviation = _data["mediaDeviation"];
      this.correctResponsePatternDeviation = _data["correctResponsePatternDeviation"];
    }
  }

  static fromJS(data: any): DeviationDto {
    data = typeof data === "object" ? data : {};
    let result = new DeviationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["textMediaTypeId"] = this.textMediaTypeId;
    data["textDeviation"] = this.textDeviation;
    data["mediaDeviation"] = this.mediaDeviation;
    data["correctResponsePatternDeviation"] = this.correctResponsePatternDeviation;
    return data;
  }
}

export interface IDeviationDto {
  textMediaTypeId?: number;
  textDeviation?: number;
  mediaDeviation?: number;
  correctResponsePatternDeviation?: number | undefined;
}

export class GenericProperty implements IGenericProperty {
  key?: string | undefined;
  defaultValue?: string | undefined;
  dataType?: number;

  constructor(data?: IGenericProperty) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data["key"];
      this.defaultValue = _data["defaultValue"];
      this.dataType = _data["dataType"];
    }
  }

  static fromJS(data: any): GenericProperty {
    data = typeof data === "object" ? data : {};
    let result = new GenericProperty();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["key"] = this.key;
    data["defaultValue"] = this.defaultValue;
    data["dataType"] = this.dataType;
    return data;
  }
}

export interface IGenericProperty {
  key?: string | undefined;
  defaultValue?: string | undefined;
  dataType?: number;
}

export class InteractionPropertyDto implements IInteractionPropertyDto {
  property?: string | undefined;
  value?: string | undefined;
  dataType?: number | undefined;
  interactionPropertyId?: number;

  constructor(data?: IInteractionPropertyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.property = _data["property"];
      this.value = _data["value"];
      this.dataType = _data["dataType"];
      this.interactionPropertyId = _data["interactionPropertyId"];
    }
  }

  static fromJS(data: any): InteractionPropertyDto {
    data = typeof data === "object" ? data : {};
    let result = new InteractionPropertyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["property"] = this.property;
    data["value"] = this.value;
    data["dataType"] = this.dataType;
    data["interactionPropertyId"] = this.interactionPropertyId;
    return data;
  }
}

export interface IInteractionPropertyDto {
  property?: string | undefined;
  value?: string | undefined;
  dataType?: number | undefined;
  interactionPropertyId?: number;
}

export class InteractionTypeDto implements IInteractionTypeDto {
  id?: number;
  name?: string | undefined;
  display?: string | undefined;
  sortOrder?: number;

  constructor(data?: IInteractionTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.display = _data["display"];
      this.sortOrder = _data["sortOrder"];
    }
  }

  static fromJS(data: any): InteractionTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new InteractionTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["display"] = this.display;
    data["sortOrder"] = this.sortOrder;
    return data;
  }
}

export interface IInteractionTypeDto {
  id?: number;
  name?: string | undefined;
  display?: string | undefined;
  sortOrder?: number;
}

export class InteractionTypeProperties implements IInteractionTypeProperties {
  property?: string | undefined;
  defaultValue?: string | undefined;
  locked?: boolean;
  render?: boolean;

  constructor(data?: IInteractionTypeProperties) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.property = _data["property"];
      this.defaultValue = _data["defaultValue"];
      this.locked = _data["locked"];
      this.render = _data["render"];
    }
  }

  static fromJS(data: any): InteractionTypeProperties {
    data = typeof data === "object" ? data : {};
    let result = new InteractionTypeProperties();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["property"] = this.property;
    data["defaultValue"] = this.defaultValue;
    data["locked"] = this.locked;
    data["render"] = this.render;
    return data;
  }
}

export interface IInteractionTypeProperties {
  property?: string | undefined;
  defaultValue?: string | undefined;
  locked?: boolean;
  render?: boolean;
}

export class InteractionTypePropertyDto implements IInteractionTypePropertyDto {
  id?: number;
  property?: string | undefined;
  interactionTypeId?: number;
  mandatory?: boolean;
  dataTypeId?: number;

  constructor(data?: IInteractionTypePropertyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.property = _data["property"];
      this.interactionTypeId = _data["interactionTypeId"];
      this.mandatory = _data["mandatory"];
      this.dataTypeId = _data["dataTypeId"];
    }
  }

  static fromJS(data: any): InteractionTypePropertyDto {
    data = typeof data === "object" ? data : {};
    let result = new InteractionTypePropertyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["property"] = this.property;
    data["interactionTypeId"] = this.interactionTypeId;
    data["mandatory"] = this.mandatory;
    data["dataTypeId"] = this.dataTypeId;
    return data;
  }
}

export interface IInteractionTypePropertyDto {
  id?: number;
  property?: string | undefined;
  interactionTypeId?: number;
  mandatory?: boolean;
  dataTypeId?: number;
}

export class ItemConfiguration implements IItemConfiguration {
  type?: ItemConfigurationType;
  randomizeOptions?: boolean | undefined;
  optionSelection?: OptionSelectionType;
  clickAreasAreVisible?: boolean | undefined;
  provider?: VideoProviderType;
  height?: string | undefined;
  width?: string | undefined;
  left?: string | undefined;
  top?: string | undefined;
  friendlyId?: string | undefined;

  constructor(data?: IItemConfiguration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.randomizeOptions = _data["randomizeOptions"];
      this.optionSelection = _data["optionSelection"];
      this.clickAreasAreVisible = _data["clickAreasAreVisible"];
      this.provider = _data["provider"];
      this.height = _data["height"];
      this.width = _data["width"];
      this.left = _data["left"];
      this.top = _data["top"];
      this.friendlyId = _data["friendlyId"];
    }
  }

  static fromJS(data: any): ItemConfiguration {
    data = typeof data === "object" ? data : {};
    let result = new ItemConfiguration();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["type"] = this.type;
    data["randomizeOptions"] = this.randomizeOptions;
    data["optionSelection"] = this.optionSelection;
    data["clickAreasAreVisible"] = this.clickAreasAreVisible;
    data["provider"] = this.provider;
    data["height"] = this.height;
    data["width"] = this.width;
    data["left"] = this.left;
    data["top"] = this.top;
    data["friendlyId"] = this.friendlyId;
    return data;
  }
}

export interface IItemConfiguration {
  type?: ItemConfigurationType;
  randomizeOptions?: boolean | undefined;
  optionSelection?: OptionSelectionType;
  clickAreasAreVisible?: boolean | undefined;
  provider?: VideoProviderType;
  height?: string | undefined;
  width?: string | undefined;
  left?: string | undefined;
  top?: string | undefined;
  friendlyId?: string | undefined;
}

export enum ItemConfigurationType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
  _11 = 11,
  _12 = 12,
  _13 = 13,
}

export class ItemDto implements IItemDto {
  type?: ItemType;
  configuration?: ItemConfiguration;
  items?: ItemDto[] | undefined;
  value?: string | undefined;
  altText?: string | undefined;
  url?: string | undefined;
  referenceKey?: ReferenceKey;
  id?: ReferenceKey;
  correctResponseKey?: ReferenceKey;
  optionId?: number | undefined;
  learningObjectives?: string[] | undefined;
  metadata?: MetaData;
  classifications?: string[] | undefined;
  tags?: string[] | undefined;
  serializedModel?: any | undefined;

  constructor(data?: IItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.configuration = _data["configuration"] ? ItemConfiguration.fromJS(_data["configuration"]) : <any>undefined;
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items!.push(ItemDto.fromJS(item));
      }
      this.value = _data["value"];
      this.altText = _data["altText"];
      this.url = _data["url"];
      this.referenceKey = _data["referenceKey"] ? ReferenceKey.fromJS(_data["referenceKey"]) : <any>undefined;
      this.id = _data["id"] ? ReferenceKey.fromJS(_data["id"]) : <any>undefined;
      this.correctResponseKey = _data["correctResponseKey"]
        ? ReferenceKey.fromJS(_data["correctResponseKey"])
        : <any>undefined;
      this.optionId = _data["optionId"];
      if (Array.isArray(_data["learningObjectives"])) {
        this.learningObjectives = [] as any;
        for (let item of _data["learningObjectives"]) this.learningObjectives!.push(item);
      }
      this.metadata = _data["metadata"] ? MetaData.fromJS(_data["metadata"]) : <any>undefined;
      if (Array.isArray(_data["classifications"])) {
        this.classifications = [] as any;
        for (let item of _data["classifications"]) this.classifications!.push(item);
      }
      if (Array.isArray(_data["tags"])) {
        this.tags = [] as any;
        for (let item of _data["tags"]) this.tags!.push(item);
      }
      this.serializedModel = _data["serializedModel"];
    }
  }

  static fromJS(data: any): ItemDto {
    data = typeof data === "object" ? data : {};
    let result = new ItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["type"] = this.type;
    data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["value"] = this.value;
    data["altText"] = this.altText;
    data["url"] = this.url;
    data["referenceKey"] = this.referenceKey ? this.referenceKey.toJSON() : <any>undefined;
    data["id"] = this.id ? this.id.toJSON() : <any>undefined;
    data["correctResponseKey"] = this.correctResponseKey ? this.correctResponseKey.toJSON() : <any>undefined;
    data["optionId"] = this.optionId;
    if (Array.isArray(this.learningObjectives)) {
      data["learningObjectives"] = [];
      for (let item of this.learningObjectives) data["learningObjectives"].push(item);
    }
    data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
    if (Array.isArray(this.classifications)) {
      data["classifications"] = [];
      for (let item of this.classifications) data["classifications"].push(item);
    }
    if (Array.isArray(this.tags)) {
      data["tags"] = [];
      for (let item of this.tags) data["tags"].push(item);
    }
    data["serializedModel"] = this.serializedModel;
    return data;
  }
}

export interface IItemDto {
  type?: ItemType;
  configuration?: ItemConfiguration;
  items?: ItemDto[] | undefined;
  value?: string | undefined;
  altText?: string | undefined;
  url?: string | undefined;
  referenceKey?: ReferenceKey;
  id?: ReferenceKey;
  correctResponseKey?: ReferenceKey;
  optionId?: number | undefined;
  learningObjectives?: string[] | undefined;
  metadata?: MetaData;
  classifications?: string[] | undefined;
  tags?: string[] | undefined;
  serializedModel?: any | undefined;
}

export enum ItemType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
  _11 = 11,
  _12 = 12,
  _13 = 13,
  _14 = 14,
  _15 = 15,
  _16 = 16,
  _17 = 17,
  _18 = 18,
  _19 = 19,
}

export class LearningObjectiveDto implements ILearningObjectiveDto {
  id?: string;

  constructor(data?: ILearningObjectiveDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): LearningObjectiveDto {
    data = typeof data === "object" ? data : {};
    let result = new LearningObjectiveDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    return data;
  }
}

export interface ILearningObjectiveDto {
  id?: string;
}

export class MediaDto implements IMediaDto {
  name?: string | undefined;
  customerId?: string;
  linkTypeId?: number;
  link?: string | undefined;

  constructor(data?: IMediaDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.customerId = _data["customerId"];
      this.linkTypeId = _data["linkTypeId"];
      this.link = _data["link"];
    }
  }

  static fromJS(data: any): MediaDto {
    data = typeof data === "object" ? data : {};
    let result = new MediaDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["customerId"] = this.customerId;
    data["linkTypeId"] = this.linkTypeId;
    data["link"] = this.link;
    return data;
  }
}

export interface IMediaDto {
  name?: string | undefined;
  customerId?: string;
  linkTypeId?: number;
  link?: string | undefined;
}

export class MetaData implements IMetaData {
  source?: Source;

  constructor(data?: IMetaData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.source = _data["source"] ? Source.fromJS(_data["source"]) : <any>undefined;
    }
  }

  static fromJS(data: any): MetaData {
    data = typeof data === "object" ? data : {};
    let result = new MetaData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["source"] = this.source ? this.source.toJSON() : <any>undefined;
    return data;
  }
}

export interface IMetaData {
  source?: Source;
}

export class MinMax implements IMinMax {
  min?: number;
  max?: number | undefined;

  constructor(data?: IMinMax) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.min = _data["min"];
      this.max = _data["max"];
    }
  }

  static fromJS(data: any): MinMax {
    data = typeof data === "object" ? data : {};
    let result = new MinMax();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["min"] = this.min;
    data["max"] = this.max;
    return data;
  }
}

export interface IMinMax {
  min?: number;
  max?: number | undefined;
}

export class OptionDto implements IOptionDto {
  optionId?: string | undefined;
  texts?: TextDto[] | undefined;
  medias?: MediaDto[] | undefined;
  sortOrder?: number;
  isCorrect?: boolean;
  group?: number;

  constructor(data?: IOptionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.optionId = _data["optionId"];
      if (Array.isArray(_data["texts"])) {
        this.texts = [] as any;
        for (let item of _data["texts"]) this.texts!.push(TextDto.fromJS(item));
      }
      if (Array.isArray(_data["medias"])) {
        this.medias = [] as any;
        for (let item of _data["medias"]) this.medias!.push(MediaDto.fromJS(item));
      }
      this.sortOrder = _data["sortOrder"];
      this.isCorrect = _data["isCorrect"];
      this.group = _data["group"];
    }
  }

  static fromJS(data: any): OptionDto {
    data = typeof data === "object" ? data : {};
    let result = new OptionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["optionId"] = this.optionId;
    if (Array.isArray(this.texts)) {
      data["texts"] = [];
      for (let item of this.texts) data["texts"].push(item.toJSON());
    }
    if (Array.isArray(this.medias)) {
      data["medias"] = [];
      for (let item of this.medias) data["medias"].push(item.toJSON());
    }
    data["sortOrder"] = this.sortOrder;
    data["isCorrect"] = this.isCorrect;
    data["group"] = this.group;
    return data;
  }
}

export interface IOptionDto {
  optionId?: string | undefined;
  texts?: TextDto[] | undefined;
  medias?: MediaDto[] | undefined;
  sortOrder?: number;
  isCorrect?: boolean;
  group?: number;
}

export enum OptionSelectionType {
  _0 = 0,
  _1 = 1,
}

export enum PublishErrorType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export class PublishQuestionResponse implements IPublishQuestionResponse {
  success?: boolean;
  publishValidationErrors?: PublishValidationError[] | undefined;

  constructor(data?: IPublishQuestionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.success = _data["success"];
      if (Array.isArray(_data["publishValidationErrors"])) {
        this.publishValidationErrors = [] as any;
        for (let item of _data["publishValidationErrors"])
          this.publishValidationErrors!.push(PublishValidationError.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PublishQuestionResponse {
    data = typeof data === "object" ? data : {};
    let result = new PublishQuestionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["success"] = this.success;
    if (Array.isArray(this.publishValidationErrors)) {
      data["publishValidationErrors"] = [];
      for (let item of this.publishValidationErrors) data["publishValidationErrors"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPublishQuestionResponse {
  success?: boolean;
  publishValidationErrors?: PublishValidationError[] | undefined;
}

export class PublishValidationError implements IPublishValidationError {
  id?: number;
  errorType?: PublishErrorType;

  constructor(data?: IPublishValidationError) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.errorType = _data["errorType"];
    }
  }

  static fromJS(data: any): PublishValidationError {
    data = typeof data === "object" ? data : {};
    let result = new PublishValidationError();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["errorType"] = this.errorType;
    return data;
  }
}

export interface IPublishValidationError {
  id?: number;
  errorType?: PublishErrorType;
}

export class QuestionDto implements IQuestionDto {
  id?: number;
  friendlyId?: string | undefined;
  identity?: string | undefined;
  interactionTypeId?: number;
  subQuestionTypeId?: number;
  templateId?: number;
  statusId?: number;
  comment?: string | undefined;
  customerId?: string | undefined;
  created?: Date;
  createdBy?: string;
  updated?: Date | undefined;
  updatedBy?: string | undefined;
  contentId?: string | undefined;
  versionId?: string | undefined;
  semanticVersion?: string | undefined;
  publishStatus?: number;
  deprecated?: boolean;
  knowledgeLevel?: number | undefined;
  classifications?: ClassificationDto[] | undefined;
  learningObjectiveDtos?: LearningObjectiveDto[] | undefined;
  interactionProperties?: InteractionPropertyDto[] | undefined;
  questionTexts?: QuestionTextDto[] | undefined;
  options?: OptionDto[] | undefined;
  questionMedia?: QuestionMediaDto[] | undefined;
  properties?: QuestionPropertyDto[] | undefined;

  constructor(data?: IQuestionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.friendlyId = _data["friendlyId"];
      this.identity = _data["identity"];
      this.interactionTypeId = _data["interactionTypeId"];
      this.subQuestionTypeId = _data["subQuestionTypeId"];
      this.templateId = _data["templateId"];
      this.statusId = _data["statusId"];
      this.comment = _data["comment"];
      this.customerId = _data["customerId"];
      this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
      this.createdBy = _data["createdBy"];
      this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
      this.updatedBy = _data["updatedBy"];
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
      this.semanticVersion = _data["semanticVersion"];
      this.publishStatus = _data["publishStatus"];
      this.deprecated = _data["deprecated"];
      this.knowledgeLevel = _data["knowledgeLevel"];
      if (Array.isArray(_data["classifications"])) {
        this.classifications = [] as any;
        for (let item of _data["classifications"]) this.classifications!.push(ClassificationDto.fromJS(item));
      }
      if (Array.isArray(_data["learningObjectiveDtos"])) {
        this.learningObjectiveDtos = [] as any;
        for (let item of _data["learningObjectiveDtos"])
          this.learningObjectiveDtos!.push(LearningObjectiveDto.fromJS(item));
      }
      if (Array.isArray(_data["interactionProperties"])) {
        this.interactionProperties = [] as any;
        for (let item of _data["interactionProperties"])
          this.interactionProperties!.push(InteractionPropertyDto.fromJS(item));
      }
      if (Array.isArray(_data["questionTexts"])) {
        this.questionTexts = [] as any;
        for (let item of _data["questionTexts"]) this.questionTexts!.push(QuestionTextDto.fromJS(item));
      }
      if (Array.isArray(_data["options"])) {
        this.options = [] as any;
        for (let item of _data["options"]) this.options!.push(OptionDto.fromJS(item));
      }
      if (Array.isArray(_data["questionMedia"])) {
        this.questionMedia = [] as any;
        for (let item of _data["questionMedia"]) this.questionMedia!.push(QuestionMediaDto.fromJS(item));
      }
      if (Array.isArray(_data["properties"])) {
        this.properties = [] as any;
        for (let item of _data["properties"]) this.properties!.push(QuestionPropertyDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QuestionDto {
    data = typeof data === "object" ? data : {};
    let result = new QuestionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["friendlyId"] = this.friendlyId;
    data["identity"] = this.identity;
    data["interactionTypeId"] = this.interactionTypeId;
    data["subQuestionTypeId"] = this.subQuestionTypeId;
    data["templateId"] = this.templateId;
    data["statusId"] = this.statusId;
    data["comment"] = this.comment;
    data["customerId"] = this.customerId;
    data["created"] = this.created ? this.created.toISOString() : <any>undefined;
    data["createdBy"] = this.createdBy;
    data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
    data["updatedBy"] = this.updatedBy;
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    data["semanticVersion"] = this.semanticVersion;
    data["publishStatus"] = this.publishStatus;
    data["deprecated"] = this.deprecated;
    data["knowledgeLevel"] = this.knowledgeLevel;
    if (Array.isArray(this.classifications)) {
      data["classifications"] = [];
      for (let item of this.classifications) data["classifications"].push(item.toJSON());
    }
    if (Array.isArray(this.learningObjectiveDtos)) {
      data["learningObjectiveDtos"] = [];
      for (let item of this.learningObjectiveDtos) data["learningObjectiveDtos"].push(item.toJSON());
    }
    if (Array.isArray(this.interactionProperties)) {
      data["interactionProperties"] = [];
      for (let item of this.interactionProperties) data["interactionProperties"].push(item.toJSON());
    }
    if (Array.isArray(this.questionTexts)) {
      data["questionTexts"] = [];
      for (let item of this.questionTexts) data["questionTexts"].push(item.toJSON());
    }
    if (Array.isArray(this.options)) {
      data["options"] = [];
      for (let item of this.options) data["options"].push(item.toJSON());
    }
    if (Array.isArray(this.questionMedia)) {
      data["questionMedia"] = [];
      for (let item of this.questionMedia) data["questionMedia"].push(item.toJSON());
    }
    if (Array.isArray(this.properties)) {
      data["properties"] = [];
      for (let item of this.properties) data["properties"].push(item.toJSON());
    }
    return data;
  }
}

export interface IQuestionDto {
  id?: number;
  friendlyId?: string | undefined;
  identity?: string | undefined;
  interactionTypeId?: number;
  subQuestionTypeId?: number;
  templateId?: number;
  statusId?: number;
  comment?: string | undefined;
  customerId?: string | undefined;
  created?: Date;
  createdBy?: string;
  updated?: Date | undefined;
  updatedBy?: string | undefined;
  contentId?: string | undefined;
  versionId?: string | undefined;
  semanticVersion?: string | undefined;
  publishStatus?: number;
  deprecated?: boolean;
  knowledgeLevel?: number | undefined;
  classifications?: ClassificationDto[] | undefined;
  learningObjectiveDtos?: LearningObjectiveDto[] | undefined;
  interactionProperties?: InteractionPropertyDto[] | undefined;
  questionTexts?: QuestionTextDto[] | undefined;
  options?: OptionDto[] | undefined;
  questionMedia?: QuestionMediaDto[] | undefined;
  properties?: QuestionPropertyDto[] | undefined;
}

export class QuestionMediaDto implements IQuestionMediaDto {
  id?: number;
  typeId?: number;
  sortOrder?: number;
  mediaTypeId?: number;
  optionId?: string | undefined;
  media?: MediaDto[] | undefined;

  constructor(data?: IQuestionMediaDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.typeId = _data["typeId"];
      this.sortOrder = _data["sortOrder"];
      this.mediaTypeId = _data["mediaTypeId"];
      this.optionId = _data["optionId"];
      if (Array.isArray(_data["media"])) {
        this.media = [] as any;
        for (let item of _data["media"]) this.media!.push(MediaDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QuestionMediaDto {
    data = typeof data === "object" ? data : {};
    let result = new QuestionMediaDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["typeId"] = this.typeId;
    data["sortOrder"] = this.sortOrder;
    data["mediaTypeId"] = this.mediaTypeId;
    data["optionId"] = this.optionId;
    if (Array.isArray(this.media)) {
      data["media"] = [];
      for (let item of this.media) data["media"].push(item.toJSON());
    }
    return data;
  }
}

export interface IQuestionMediaDto {
  id?: number;
  typeId?: number;
  sortOrder?: number;
  mediaTypeId?: number;
  optionId?: string | undefined;
  media?: MediaDto[] | undefined;
}

export class QuestionPropertyDto implements IQuestionPropertyDto {
  key?: string | undefined;
  value?: string | undefined;
  dataType?: number;

  constructor(data?: IQuestionPropertyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data["key"];
      this.value = _data["value"];
      this.dataType = _data["dataType"];
    }
  }

  static fromJS(data: any): QuestionPropertyDto {
    data = typeof data === "object" ? data : {};
    let result = new QuestionPropertyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["key"] = this.key;
    data["value"] = this.value;
    data["dataType"] = this.dataType;
    return data;
  }
}

export interface IQuestionPropertyDto {
  key?: string | undefined;
  value?: string | undefined;
  dataType?: number;
}

export class QuestionPublishRequest implements IQuestionPublishRequest {
  questionId?: number;
  semanticVersion?: string | undefined;
  ignoreValidation?: boolean;
  owner?: string | undefined;
  origin?: string | undefined;

  constructor(data?: IQuestionPublishRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.questionId = _data["questionId"];
      this.semanticVersion = _data["semanticVersion"];
      this.ignoreValidation = _data["ignoreValidation"];
      this.owner = _data["owner"];
      this.origin = _data["origin"];
    }
  }

  static fromJS(data: any): QuestionPublishRequest {
    data = typeof data === "object" ? data : {};
    let result = new QuestionPublishRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["questionId"] = this.questionId;
    data["semanticVersion"] = this.semanticVersion;
    data["ignoreValidation"] = this.ignoreValidation;
    data["owner"] = this.owner;
    data["origin"] = this.origin;
    return data;
  }
}

export interface IQuestionPublishRequest {
  questionId?: number;
  semanticVersion?: string | undefined;
  ignoreValidation?: boolean;
  owner?: string | undefined;
  origin?: string | undefined;
}

export class QuestionTextDto implements IQuestionTextDto {
  id?: number;
  textTypeId?: number;
  sortOrder?: number;
  optionId?: string | undefined;
  texts?: TextDto[] | undefined;

  constructor(data?: IQuestionTextDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.textTypeId = _data["textTypeId"];
      this.sortOrder = _data["sortOrder"];
      this.optionId = _data["optionId"];
      if (Array.isArray(_data["texts"])) {
        this.texts = [] as any;
        for (let item of _data["texts"]) this.texts!.push(TextDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QuestionTextDto {
    data = typeof data === "object" ? data : {};
    let result = new QuestionTextDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["textTypeId"] = this.textTypeId;
    data["sortOrder"] = this.sortOrder;
    data["optionId"] = this.optionId;
    if (Array.isArray(this.texts)) {
      data["texts"] = [];
      for (let item of this.texts) data["texts"].push(item.toJSON());
    }
    return data;
  }
}

export interface IQuestionTextDto {
  id?: number;
  textTypeId?: number;
  sortOrder?: number;
  optionId?: string | undefined;
  texts?: TextDto[] | undefined;
}

export class ReferenceKey implements IReferenceKey {
  contentId?: string;
  versionId?: string;

  constructor(data?: IReferenceKey) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
    }
  }

  static fromJS(data: any): ReferenceKey {
    data = typeof data === "object" ? data : {};
    let result = new ReferenceKey();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    return data;
  }
}

export interface IReferenceKey {
  contentId?: string;
  versionId?: string;
}

export class Scope implements IScope {
  scopeItems?: ScopeItem[] | undefined;

  constructor(data?: IScope) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["scopeItems"])) {
        this.scopeItems = [] as any;
        for (let item of _data["scopeItems"]) this.scopeItems!.push(ScopeItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Scope {
    data = typeof data === "object" ? data : {};
    let result = new Scope();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.scopeItems)) {
      data["scopeItems"] = [];
      for (let item of this.scopeItems) data["scopeItems"].push(item.toJSON());
    }
    return data;
  }
}

export interface IScope {
  scopeItems?: ScopeItem[] | undefined;
}

export class ScopeItem implements IScopeItem {
  rootIdentifier?: string;
  classificationIdentifier?: string;

  constructor(data?: IScopeItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rootIdentifier = _data["rootIdentifier"];
      this.classificationIdentifier = _data["classificationIdentifier"];
    }
  }

  static fromJS(data: any): ScopeItem {
    data = typeof data === "object" ? data : {};
    let result = new ScopeItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rootIdentifier"] = this.rootIdentifier;
    data["classificationIdentifier"] = this.classificationIdentifier;
    return data;
  }
}

export interface IScopeItem {
  rootIdentifier?: string;
  classificationIdentifier?: string;
}

export class Source implements ISource {
  id?: string | undefined;
  identifier?: string | undefined;
  name?: string | undefined;

  constructor(data?: ISource) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.identifier = _data["identifier"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): Source {
    data = typeof data === "object" ? data : {};
    let result = new Source();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["identifier"] = this.identifier;
    data["name"] = this.name;
    return data;
  }
}

export interface ISource {
  id?: string | undefined;
  identifier?: string | undefined;
  name?: string | undefined;
}

export class StatusDto implements IStatusDto {
  id?: number;
  name?: string | undefined;

  constructor(data?: IStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): StatusDto {
    data = typeof data === "object" ? data : {};
    let result = new StatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface IStatusDto {
  id?: number;
  name?: string | undefined;
}

export class TemplateData implements ITemplateData {
  interactionType?: number | undefined;
  subQuestionType?: number | undefined;
  textAndMedia?: TextAndMedia[] | undefined;
  interactionProperties?: InteractionTypeProperties[] | undefined;
  configuration?: Configuration[] | undefined;
  classifications?: ClassificationDto[] | undefined;
  properties?: GenericProperty[] | undefined;

  constructor(data?: ITemplateData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.interactionType = _data["interactionType"];
      this.subQuestionType = _data["subQuestionType"];
      if (Array.isArray(_data["textAndMedia"])) {
        this.textAndMedia = [] as any;
        for (let item of _data["textAndMedia"]) this.textAndMedia!.push(TextAndMedia.fromJS(item));
      }
      if (Array.isArray(_data["interactionProperties"])) {
        this.interactionProperties = [] as any;
        for (let item of _data["interactionProperties"])
          this.interactionProperties!.push(InteractionTypeProperties.fromJS(item));
      }
      if (Array.isArray(_data["configuration"])) {
        this.configuration = [] as any;
        for (let item of _data["configuration"]) this.configuration!.push(Configuration.fromJS(item));
      }
      if (Array.isArray(_data["classifications"])) {
        this.classifications = [] as any;
        for (let item of _data["classifications"]) this.classifications!.push(ClassificationDto.fromJS(item));
      }
      if (Array.isArray(_data["properties"])) {
        this.properties = [] as any;
        for (let item of _data["properties"]) this.properties!.push(GenericProperty.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TemplateData {
    data = typeof data === "object" ? data : {};
    let result = new TemplateData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["interactionType"] = this.interactionType;
    data["subQuestionType"] = this.subQuestionType;
    if (Array.isArray(this.textAndMedia)) {
      data["textAndMedia"] = [];
      for (let item of this.textAndMedia) data["textAndMedia"].push(item.toJSON());
    }
    if (Array.isArray(this.interactionProperties)) {
      data["interactionProperties"] = [];
      for (let item of this.interactionProperties) data["interactionProperties"].push(item.toJSON());
    }
    if (Array.isArray(this.configuration)) {
      data["configuration"] = [];
      for (let item of this.configuration) data["configuration"].push(item.toJSON());
    }
    if (Array.isArray(this.classifications)) {
      data["classifications"] = [];
      for (let item of this.classifications) data["classifications"].push(item.toJSON());
    }
    if (Array.isArray(this.properties)) {
      data["properties"] = [];
      for (let item of this.properties) data["properties"].push(item.toJSON());
    }
    return data;
  }
}

export interface ITemplateData {
  interactionType?: number | undefined;
  subQuestionType?: number | undefined;
  textAndMedia?: TextAndMedia[] | undefined;
  interactionProperties?: InteractionTypeProperties[] | undefined;
  configuration?: Configuration[] | undefined;
  classifications?: ClassificationDto[] | undefined;
  properties?: GenericProperty[] | undefined;
}

export class TemplateDto implements ITemplateDto {
  id?: number | undefined;
  name?: string | undefined;
  description?: string | undefined;
  interactionTypeId?: number | undefined;
  customerId?: string | undefined;
  sortOrder?: number;
  template?: TemplateData;

  constructor(data?: ITemplateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.interactionTypeId = _data["interactionTypeId"];
      this.customerId = _data["customerId"];
      this.sortOrder = _data["sortOrder"];
      this.template = _data["template"] ? TemplateData.fromJS(_data["template"]) : <any>undefined;
    }
  }

  static fromJS(data: any): TemplateDto {
    data = typeof data === "object" ? data : {};
    let result = new TemplateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    data["interactionTypeId"] = this.interactionTypeId;
    data["customerId"] = this.customerId;
    data["sortOrder"] = this.sortOrder;
    data["template"] = this.template ? this.template.toJSON() : <any>undefined;
    return data;
  }
}

export interface ITemplateDto {
  id?: number | undefined;
  name?: string | undefined;
  description?: string | undefined;
  interactionTypeId?: number | undefined;
  customerId?: string | undefined;
  sortOrder?: number;
  template?: TemplateData;
}

export class TextAndMedia implements ITextAndMedia {
  textMediaTypeId?: number;
  text?: MinMax;
  media?: MinMax;
  sortOrder?: number;

  constructor(data?: ITextAndMedia) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.textMediaTypeId = _data["textMediaTypeId"];
      this.text = _data["text"] ? MinMax.fromJS(_data["text"]) : <any>undefined;
      this.media = _data["media"] ? MinMax.fromJS(_data["media"]) : <any>undefined;
      this.sortOrder = _data["sortOrder"];
    }
  }

  static fromJS(data: any): TextAndMedia {
    data = typeof data === "object" ? data : {};
    let result = new TextAndMedia();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["textMediaTypeId"] = this.textMediaTypeId;
    data["text"] = this.text ? this.text.toJSON() : <any>undefined;
    data["media"] = this.media ? this.media.toJSON() : <any>undefined;
    data["sortOrder"] = this.sortOrder;
    return data;
  }
}

export interface ITextAndMedia {
  textMediaTypeId?: number;
  text?: MinMax;
  media?: MinMax;
  sortOrder?: number;
}

export class TextAndMediaTypesDto implements ITextAndMediaTypesDto {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;

  constructor(data?: ITextAndMediaTypesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): TextAndMediaTypesDto {
    data = typeof data === "object" ? data : {};
    let result = new TextAndMediaTypesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    return data;
  }
}

export interface ITextAndMediaTypesDto {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
}

export class TextDto implements ITextDto {
  text?: string | undefined;
  customerId?: string;
  formatId?: number;

  constructor(data?: ITextDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.text = _data["text"];
      this.customerId = _data["customerId"];
      this.formatId = _data["formatId"];
    }
  }

  static fromJS(data: any): TextDto {
    data = typeof data === "object" ? data : {};
    let result = new TextDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["text"] = this.text;
    data["customerId"] = this.customerId;
    data["formatId"] = this.formatId;
    return data;
  }
}

export interface ITextDto {
  text?: string | undefined;
  customerId?: string;
  formatId?: number;
}

export class UserDto implements IUserDto {
  id?: number;
  externalId?: string;
  name?: string | undefined;
  link?: string | undefined;
  rights?: string[] | undefined;
  jwtBearerToken?: string | undefined;
  roles?: string[] | undefined;

  constructor(data?: IUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.externalId = _data["externalId"];
      this.name = _data["name"];
      this.link = _data["link"];
      if (Array.isArray(_data["rights"])) {
        this.rights = [] as any;
        for (let item of _data["rights"]) this.rights!.push(item);
      }
      this.jwtBearerToken = _data["jwtBearerToken"];
      if (Array.isArray(_data["roles"])) {
        this.roles = [] as any;
        for (let item of _data["roles"]) this.roles!.push(item);
      }
    }
  }

  static fromJS(data: any): UserDto {
    data = typeof data === "object" ? data : {};
    let result = new UserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["externalId"] = this.externalId;
    data["name"] = this.name;
    data["link"] = this.link;
    if (Array.isArray(this.rights)) {
      data["rights"] = [];
      for (let item of this.rights) data["rights"].push(item);
    }
    data["jwtBearerToken"] = this.jwtBearerToken;
    if (Array.isArray(this.roles)) {
      data["roles"] = [];
      for (let item of this.roles) data["roles"].push(item);
    }
    return data;
  }
}

export interface IUserDto {
  id?: number;
  externalId?: string;
  name?: string | undefined;
  link?: string | undefined;
  rights?: string[] | undefined;
  jwtBearerToken?: string | undefined;
  roles?: string[] | undefined;
}

export class ValidationDto implements IValidationDto {
  success?: boolean;
  deviations?: DeviationDto[] | undefined;

  constructor(data?: IValidationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.success = _data["success"];
      if (Array.isArray(_data["deviations"])) {
        this.deviations = [] as any;
        for (let item of _data["deviations"]) this.deviations!.push(DeviationDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ValidationDto {
    data = typeof data === "object" ? data : {};
    let result = new ValidationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["success"] = this.success;
    if (Array.isArray(this.deviations)) {
      data["deviations"] = [];
      for (let item of this.deviations) data["deviations"].push(item.toJSON());
    }
    return data;
  }
}

export interface IValidationDto {
  success?: boolean;
  deviations?: DeviationDto[] | undefined;
}

export enum VideoProviderType {
  _0 = 0,
}

export class WhereUsedDto implements IWhereUsedDto {
  id?: number;
  name?: string | undefined;
  published?: boolean;
  type?: WhereUsedType;
  classificationIds?: string[] | undefined;

  constructor(data?: IWhereUsedDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.published = _data["published"];
      this.type = _data["type"];
      if (Array.isArray(_data["classificationIds"])) {
        this.classificationIds = [] as any;
        for (let item of _data["classificationIds"]) this.classificationIds!.push(item);
      }
    }
  }

  static fromJS(data: any): WhereUsedDto {
    data = typeof data === "object" ? data : {};
    let result = new WhereUsedDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["published"] = this.published;
    data["type"] = this.type;
    if (Array.isArray(this.classificationIds)) {
      data["classificationIds"] = [];
      for (let item of this.classificationIds) data["classificationIds"].push(item);
    }
    return data;
  }
}

export interface IWhereUsedDto {
  id?: number;
  name?: string | undefined;
  published?: boolean;
  type?: WhereUsedType;
  classificationIds?: string[] | undefined;
}

export class WhereUsedImageRequest implements IWhereUsedImageRequest {
  contentId?: string;
  versionId?: string;

  constructor(data?: IWhereUsedImageRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
    }
  }

  static fromJS(data: any): WhereUsedImageRequest {
    data = typeof data === "object" ? data : {};
    let result = new WhereUsedImageRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    return data;
  }
}

export interface IWhereUsedImageRequest {
  contentId?: string;
  versionId?: string;
}

export enum WhereUsedType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
